import { convertClustersToFlatFeaturesMap } from './convertClustersToFlatFeaturesMap';
import { convertFrecklesToFeaturesMap } from './convertFrecklesToFeaturesMap';
import { IMapMappedResponse } from '../../../Map/types/mappedResponse';
import { IPublicWebV1MapResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1MapResponse';

export const mapResponse200 = (response: IPublicWebV1MapResponse): IMapMappedResponse => ({
  ...response,
  clusters: convertClustersToFlatFeaturesMap(response.clusters),
  freckles: convertFrecklesToFeaturesMap(response.freckles),
});
